import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { HashLink as Link } from "react-router-hash-link";
import { setFilterData } from "../../actions/FiltersActions";
import "./CustomLink.css";

CustomLink.propTypes = {
  content: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.string,
  to: PropTypes.string.isRequired,
  style: PropTypes.object,
};

function CustomLink(props) {
  const { content, to, style = {}, value, label } = props;
  return (
    <Link
      to={to}
      onClick={() => props.handleChange(value, label, "scope_activity")}
      className="CustomLink"
      role="link"
      style={{ ...style }}
    >
      {content}
    </Link>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleChange: (val, label, type) => {
      dispatch(setFilterData(val, label, type));
    },
  };
};

export default connect(null, mapDispatchToProps)(CustomLink);



// WEBPACK FOOTER //
// ./src/components/CustomLink/index.js